/**
 * @desc 取消退款单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.RefundOrderOperationDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/asRefundOrder/refundOrderCancel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
